import { AccountBadgePreview } from '../../../../ui/features/badge-preview/components/AccountBadgePreview';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
export const AccountBadgePreviewModal = (props) => {
    const { t } = useBadgingTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, { id: props.ariaTitleId }, t('badgePreview.previewModalTitle', {
            title: props.accountBadge.columns.badgeName,
        })),
        React.createElement(DialogContent, { sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }, id: props.ariaContentId },
            React.createElement(Box, { sx: {
                    px: 5,
                    py: 2,
                    borderRadius: 1,
                    backgroundColor: themeColors.surface.secondary,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                } },
                React.createElement(AccountBadgePreview, { accountBadge: props.accountBadge, enablePrintedPdfDownload: true }))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { variant: 'text', color: 'primary', onClick: () => props.close() }, t('badges.badgeCard.close')))));
};
